import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';
import { CreateApplicationFromTokenInput, CreateApplicationFromTokenResponse } from '../interfaces/create-application-from-token';
import { TokenResponse } from '../interfaces/token-response';

class ApplicationsResource extends Resource {
  constructor() {
    super('application', httpResource);
  }

  public getToken(championshipId: number, teamId: number): Promise<TokenResponse> {
    return this.child('token').get({ championshipId, teamId });
  }

  public createFromToken(data: CreateApplicationFromTokenInput): Promise<CreateApplicationFromTokenResponse> {
    const { photo, ...rest } = data;

    const formData = new FormData();
    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, String(value));
      }
    });
    if (photo) {
      formData.append('photo', photo);
    }

    return this.child('create-from-token-v2').post(formData);
  }
}

const applicationsResource = new ApplicationsResource();
export default applicationsResource;
